import React from 'react';
import { Title } from 'components';
import { Card, CardProps } from 'components/Card';
import { useBreakpoint } from 'hooks';
import styled from 'styled-components';

const BasicCard: React.FC<CardProps> = ({
  title,
  children,
  headStyle,
  ...otherCardProps
}) => (
    <StyledCard
      title={<Title>{title}</Title>}
      headStyle={{ borderBottom: 'unset', ...headStyle }}
      {...otherCardProps}
    >
      {children}
    </StyledCard>
  );

const StyledCard = styled(Card)`
  width: 100%;
`;

export default BasicCard;
